module.exports = __webpack_public_path__ + "static/media/icon13.371a34ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon13.png
// module id = 742
// module chunks = 0 1